import * as React from "react";
import "./Login.css";


export default class Login extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    window.localStorage.setItem("account", "{}");
    this.login();
  }


  login() {
    fetch("public/clientConfirm", {
      method: "post",
      body: JSON.stringify({token: window.location.href.split("?token=").pop()}),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        console.log(data)
        data.client.type = "client"
        window.localStorage.setItem("account", JSON.stringify(data.client));
        this.props.history.push("/campaigns");
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  }

  public render() {
    return (<></>);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/ClientConfirm.tsx